<template>
  <div class="steps">
    <template v-if="isStepMode">
      <h1>{{resource["forgotPassword.PassStepsTitle"]}}</h1>
      <ul>
        <li>
          <div class="description">
            {{resource["forgotPassword.PassStepsDescOne"]}}
          </div>
        </li>
        <li>
          <div class="description">
            {{resource["forgotPassword.PassStepsDescTwo"]}}
          </div>
        </li>
        <li>
          <div class="description">
            {{resource["forgotPassword.PassStepsDescThree"]}}
          </div>
        </li>
      </ul>
    </template>
    <template v-else>
      <h1>{{resource["forgotPassword.PassStepsDescFour"]}}</h1>
      <ul>
        <li>
          <div class="description">
            {{resource["forgotPassword.PassStepsDescFive"]}}
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ResetPasswordSteps',
  props: {
    isResult: {
      type: Boolean,
      default: () => false,
    },
    isStepMode: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>

<style scoped lang="scss">
  .steps {
    position: relative;
    text-align: left;
    max-width: 400px;

    h1 {
      margin-top: 62px;
      padding-bottom: 10px;
      color: #4C4C4C;
      border-bottom: 1px solid white;
    }
    ul {
      padding-left: 15px;
      color: #4C4C4C;
      li {
        list-style: none;
        font-size: 15px;
        margin-top: 15px;
        .description {
          opacity: 0.8;
        }
        &::before {
          content: "●";
          position: absolute;
          border-radius: 50%;
          margin-top: -1px;
          left: -2px; /* Adjust this value so that it appears where you want. */
          font-size: 1.1em;
        }
      }
    }
  }
</style>
